import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { formatProductOptionLabel } from "../pricing-reports/constants";

export default function FlyerReportFilters({
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  provinceChoices,
  selectedProvince,
  setSelectedProvince,
  flyerProductFilterChoices,
  selectedProduct,
  setSelectedProduct,
  retailerChoices,
  selectedRetailer,
  setSelectedRetailer,
  isLoadingFilterOptions,
  isProductFilterChoicesLoading,
}) {
  return (
    <Box>
      <Typography className="form-section-title" variant="h4" component="h4">
        Flyer Report
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
        Explore promotions from retail flyer market analysis price history.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="From"
            value={dateFrom}
            onChange={setDateFrom}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="To"
            value={dateTo}
            onChange={setDateTo}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            fullWidth
            size="small"
            options={provinceChoices}
            value={selectedProvince}
            onChange={(_, nextProvince) => setSelectedProvince(nextProvince)}
            getOptionLabel={(option) => option?.label ?? ""}
            isOptionEqualToValue={(left, right) => left?.value === right?.value}
            renderInput={(params) => <TextField {...params} label="Province" />}
            loading={isLoadingFilterOptions}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            fullWidth
            size="small"
            options={flyerProductFilterChoices}
            value={selectedProduct}
            onChange={(_, nextProduct) => setSelectedProduct(nextProduct)}
            getOptionLabel={(product) => formatProductOptionLabel(product)}
            isOptionEqualToValue={(left, right) => left?.id === right?.id}
            renderOption={(props, option) => {
              const { key: _ignoredMuiKey, ...listItemProps } = props;
              return (
                <Box component="li" key={option.id} {...listItemProps}>
                  {formatProductOptionLabel(option)}
                </Box>
              );
            }}
            renderInput={(params) => <TextField {...params} label="Product" />}
            loading={isLoadingFilterOptions || isProductFilterChoicesLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            fullWidth
            size="small"
            options={retailerChoices}
            value={selectedRetailer}
            onChange={(_, nextRetailer) => setSelectedRetailer(nextRetailer)}
            getOptionLabel={(retailer) => retailer ?? ""}
            isOptionEqualToValue={(left, right) => left === right}
            renderInput={(params) => <TextField {...params} label="Retailer" />}
            loading={isLoadingFilterOptions}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
